/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserFriends} from '@fortawesome/pro-duotone-svg-icons';

const OtherContactsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUserFriends} {...props} />
);

export default OtherContactsIcon;
